var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1D3F7B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.428 7.885V5.572h-2.434c.88.557 1.854 1.462 2.434 2.313M8.071 5.572h-2.5v2.371c.517-.982 1.485-1.881 2.5-2.371m-2.5 10.485v2.372h2.466c-.882-.567-1.889-1.51-2.466-2.372m10.464 2.372h2.393v-2.313c-.571.837-1.532 1.759-2.393 2.313"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.818 18.857v-.006c3.888 0 7.039-3.068 7.039-6.854c0-3.78-3.151-6.854-7.039-6.854c-3.62.189-6.675 3.184-6.675 6.857s3.056 6.669 6.675 6.857m.175-12c-2.801.004-5.14 2.349-5.136 5.15s2.348 5.14 5.15 5.136c2.8-.004 5.139-2.349 5.136-5.15c-.004-2.8-2.349-5.14-5.15-5.136",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmni);
export default __webpack_public_path__ + "static/media/omni.7315990c98d38734128707c91197298c.svg";
export { ForwardRef as ReactComponent };